import Vue from "vue";
import Vuex, { StoreOptions } from "vuex";
import VuexPersist from "@/plugins/vuex-persist";
import { RootState } from "@/store/modules/general/types";
import { general } from './modules/general/index';
import { auth } from './modules/auth/index';
import { SeleccionCliente } from "./modules/SeleccionCliente";
import { ventas } from "./modules/ventas";
import { Historico } from "./modules/Historico";
import { PedidoCompletados } from "./modules/PedidoCompletados";
import { FinalizarPedido } from "./modules/FinalizarPedido";
import { facturas } from "./modules/Facturas";
import { Proveedores } from "./modules/Proveedores";

Vue.use(Vuex);

const store: StoreOptions<RootState> = {
  state: {
    appName: "Demo",
    appVersion: "1.0.0",
    menu: true,
    lang: "es",
    loading: false,
    isMobile: false,
    id: 1,
  },
  modules: {
    auth,
    general,
    SeleccionCliente,
    ventas,
    Historico,
    PedidoCompletados,
    FinalizarPedido,
    facturas,
    Proveedores
  },
  actions:{
    updateKey(context){
      context.commit('setKey');
    },
    screenResize(context) {
      context.commit('onResize', window.innerWidth < 600);
    }
  },
  mutations: {
    setKey(state: RootState){
      state.id++;
    },
    onResize(state: RootState, valor: boolean) {
      state.isMobile = valor;
    }
  },
  plugins: [VuexPersist.plugin],
};

export default new Vuex.Store<RootState>(store);
